(ns common.schema.entities.survey.survey-reference-periods
  (:require [common.dates :as dates]))

(def MONTH :reference-period/month)
(def QUARTER :reference-period/quarter)
(def HALF_YEAR :reference-period/half-year)
(def YEAR :reference-period/year)

(def localizations
  {:en {:reference-period/month     "Month"
        :reference-period/quarter   "Quarter"
        :reference-period/half-year "Half year"
        :reference-period/year      "Year"}})

(def reference-periods [MONTH QUARTER HALF_YEAR YEAR])

(defn options
  [lang]
  (->> reference-periods
       (mapv (fn [k]
               {:value k
                :label (get-in localizations [(or lang :en) k])}))))


(defn period-options
  "Concrete reference periods of `period-type` in the calendar years from five
  years before the current year to four years after it. The same options a
  survey is sent with."
  [period-type]
  (let [now (dates/date-time)]
    (case period-type
      :reference-period/year (->> (range -5 5)
                                  (map (fn [year-diff]
                                         (let [date-in-period (dates/plus now (dates/years year-diff))
                                               start-dt (dates/start-of-year date-in-period)
                                               end-dt (dates/end-of-year date-in-period)
                                               start-time (dates/start-of-day start-dt)
                                               end-time (dates/end-of-day end-dt)
                                               start-ts (dates/epoch-millis start-time)
                                               end-ts (dates/epoch-millis end-time)]
                                           {:value    (str start-ts "-" end-ts)
                                            :start-ts start-ts
                                            :end-ts   end-ts
                                            :label    (str (dates/format start-time {:pattern  "d.MMM"
                                                                                     :timezone "Etc/UTC"})
                                                           " - "
                                                           (dates/format end-time {:pattern  "d.MMM.yyyy"
                                                                                   :timezone "Etc/UTC"}))})))
                                  (vec))
      :reference-period/quarter (->> (range -5 5)
                                     (mapcat (fn [year-diff]
                                               (let [date-in-period (dates/plus now (dates/years year-diff))
                                                     start-dt (dates/start-of-year date-in-period)]
                                                 (->> (range 0 4)
                                                      (map (fn [q]
                                                             (let [date-in-start-month (dates/plus start-dt (dates/months (* q 3)))
                                                                   start-time (dates/start-of-month date-in-start-month)
                                                                   date-in-end-month (dates/plus date-in-start-month (dates/months 2))
                                                                   end-time (dates/end-of-month date-in-end-month)
                                                                   start-of-day (dates/start-of-day start-time)
                                                                   end-of-day (dates/end-of-day end-time)
                                                                   start-ts (dates/epoch-millis start-of-day)
                                                                   end-ts (dates/epoch-millis end-of-day)]
                                                               {:value    (str start-ts "-" end-ts)
                                                                :start-ts start-ts
                                                                :end-ts   end-ts
                                                                :label    (str (dates/format start-time {:pattern  "yyyy"
                                                                                                         :timezone "Etc/UTC"})
                                                                               "/Q" (inc q)

                                                                               " | "
                                                                               (dates/format start-time {:pattern  "dd.MM.yyyy"
                                                                                                         :timezone "Etc/UTC"})
                                                                               " -> "
                                                                               (dates/format end-time {:pattern  "dd.MM.yyyy"
                                                                                                       :timezone "Etc/UTC"}))})))))))
                                     (vec))
      :reference-period/half-year (->> (range -5 5)
                                       (mapcat (fn [year-diff]
                                                 (let [date-in-period (dates/plus now (dates/years year-diff))
                                                       start-dt (dates/start-of-year date-in-period)
                                                       end-dt (dates/end-of-year date-in-period)
                                                       start-1h-time (dates/start-of-day start-dt)
                                                       end-2h-time (dates/end-of-day end-dt)
                                                       start-1h-ts (dates/epoch-millis start-1h-time)
                                                       end-2h-ts (dates/epoch-millis end-2h-time)
                                                       date-end-of-1H-month (dates/plus start-dt (dates/months 5))
                                                       date-start-of-2H-month (dates/plus start-dt (dates/months 6))
                                                       start-2h-time (dates/start-of-month date-start-of-2H-month)
                                                       end-1h-time (dates/end-of-month date-end-of-1H-month)
                                                       start-of-day-2h (dates/start-of-day start-2h-time)
                                                       end-of-1h-day (dates/end-of-day end-1h-time)
                                                       start-2h-ts (dates/epoch-millis start-of-day-2h)
                                                       end-1h-ts (dates/epoch-millis end-of-1h-day)]
                                                   [{:value    (str start-1h-ts "-" end-1h-ts)
                                                     :start-ts start-1h-ts
                                                     :end-ts   end-1h-ts
                                                     :label    (str (dates/format start-1h-time {:pattern  "yyyy"
                                                                                                 :timezone "Etc/UTC"})
                                                                    "/H1"

                                                                    " | "
                                                                    (dates/format start-1h-time {:pattern  "dd.MM.yyyy"
                                                                                                 :timezone "Etc/UTC"})
                                                                    " -> "
                                                                    (dates/format end-1h-time {:pattern  "dd.MM.yyyy"
                                                                                               :timezone "Etc/UTC"}))}
                                                    {:value    (str start-2h-ts "-" end-2h-ts)
                                                     :start-ts start-2h-ts
                                                     :end-ts   end-2h-ts
                                                     :label    (str (dates/format start-2h-time {:pattern  "yyyy"
                                                                                                 :timezone "Etc/UTC"})
                                                                    "/H2"

                                                                    " | "
                                                                    (dates/format start-2h-time {:pattern  "dd.MM.yyyy"
                                                                                                 :timezone "Etc/UTC"})
                                                                    " -> "
                                                                    (dates/format end-2h-time {:pattern  "dd.MM.yyyy"
                                                                                               :timezone "Etc/UTC"}))}])))
                                       (vec))
      :reference-period/month (->> (range -5 5)
                                   (mapcat (fn [year-diff]
                                             (let [date-in-period (dates/plus now (dates/years year-diff))
                                                   start-dt (dates/start-of-year date-in-period)]
                                               (->> (range 0 12)
                                                    (map (fn [q]
                                                           (let [date-in-start-month (dates/plus start-dt (dates/months q))
                                                                 start-time (dates/start-of-month date-in-start-month)
                                                                 end-time (dates/end-of-month date-in-start-month)
                                                                 start-of-day (dates/start-of-day start-time)
                                                                 end-of-day (dates/end-of-day end-time)
                                                                 start-ts (dates/epoch-millis start-of-day)
                                                                 end-ts (dates/epoch-millis end-of-day)]
                                                             {:value    (str start-ts "-" end-ts)
                                                              :start-ts start-ts
                                                              :end-ts   end-ts
                                                              :label    (str (dates/format start-time {:pattern  "yyyy"
                                                                                                       :timezone "Etc/UTC"})
                                                                             "/" (inc q))})))))))
                                   (vec)))))

(defn last-complete-period
  "The latest of `period-options` that ended before `now-ms`. The default
  period a survey is sent with."
  [period-options now-ms]
  (->> period-options
       (sort-by :end-ts)
       (reverse)
       (filter (fn [{:keys [end-ts]}]
                 (< end-ts now-ms)))
       (first)))

(defn option-value
  [start-ts end-ts]
  (str start-ts "-" end-ts))

(def all-reference-periods* (atom {}))
(def ref-periods-by-value* (atom {}))

(defn init-reference-periods
  []
  (let [date-now (dates/date-time)]
    (reset! all-reference-periods*
            (vec
             (concat
              ;:reference-period/year
              (->> (range -50 50)
                   (mapv (fn [year-diff]
                           (let [date-in-period (dates/plus date-now (dates/years year-diff))
                                 start-dt (dates/start-of-year date-in-period)
                                 end-dt (dates/end-of-year date-in-period)
                                 start-time (dates/start-of-day start-dt)
                                 end-time (dates/end-of-day end-dt)
                                 start-ts (dates/epoch-millis start-time)
                                 end-ts (dates/epoch-millis end-time)]
                             {:value        (option-value start-ts end-ts)
                              :start-ts     start-ts
                              :end-ts       end-ts
                              :period-type  :reference-period/year
                              :period-index (dates/get-full-year date-in-period)
                              :label        (str (dates/format start-time {:pattern  "d.MMM"
                                                                           :timezone "Etc/UTC"})
                                                 " - "
                                                 (dates/format end-time {:pattern  "d.MMM.yyyy"
                                                                         :timezone "Etc/UTC"}))}))))
              ;:reference-period/quarter
              (->> (range -50 50)
                   (mapcat (fn [year-diff]
                             (let [date-in-period (dates/plus date-now (dates/years year-diff))
                                   start-dt (dates/start-of-year date-in-period)]
                               (->> (range 0 4)
                                    (mapv (fn [q]
                                            (let [date-in-start-month (dates/plus start-dt (dates/months (* q 3)))
                                                  start-time (dates/start-of-month date-in-start-month)
                                                  date-in-end-month (dates/plus date-in-start-month (dates/months 2))
                                                  end-time (dates/end-of-month date-in-end-month)
                                                  start-of-day (dates/start-of-day start-time)
                                                  end-of-day (dates/end-of-day end-time)
                                                  start-ts (dates/epoch-millis start-of-day)
                                                  end-ts (dates/epoch-millis end-of-day)]
                                              {:value        (option-value start-ts end-ts)
                                               :start-ts     start-ts
                                               :end-ts       end-ts
                                               :period-type  :reference-period/quarter
                                               :period-index q
                                               :label        (str (dates/format start-time {:pattern  "yyyy"
                                                                                            :timezone "Etc/UTC"})
                                                                  "/Q" (inc q)

                                                                  " | "
                                                                  (dates/format start-time {:pattern  "dd.MM.yyyy"
                                                                                            :timezone "Etc/UTC"})
                                                                  " -> "
                                                                  (dates/format end-time {:pattern  "dd.MM.yyyy"
                                                                                          :timezone "Etc/UTC"})
                                                                  )}))))))))
              ;:reference-period/half-year
              (->> (range -5 5)
                   (mapcat (fn [year-diff]
                             (let [date-in-period (dates/plus date-now (dates/years year-diff))
                                   start-dt (dates/start-of-year date-in-period)
                                   end-dt (dates/end-of-year date-in-period)
                                   start-1h-time (dates/start-of-day start-dt)
                                   end-2h-time (dates/end-of-day end-dt)
                                   start-1h-ts (dates/epoch-millis start-1h-time)
                                   end-2h-ts (dates/epoch-millis end-2h-time)
                                   date-end-of-1H-month (dates/plus start-dt (dates/months 5))
                                   date-start-of-2H-month (dates/plus start-dt (dates/months 6))
                                   start-2h-time (dates/start-of-month date-start-of-2H-month)
                                   end-1h-time (dates/end-of-month date-end-of-1H-month)
                                   start-of-day-2h (dates/start-of-day start-2h-time)
                                   end-of-1h-day (dates/end-of-day end-1h-time)
                                   start-2h-ts (dates/epoch-millis start-of-day-2h)
                                   end-1h-ts (dates/epoch-millis end-of-1h-day)]
                               [{:value        (option-value start-1h-ts end-1h-ts)
                                 :start-ts     start-1h-ts
                                 :end-ts       end-1h-ts
                                 :period-type  :reference-period/half-year
                                 :period-index 0
                                 :label        (str (dates/format start-1h-time {:pattern  "yyyy"
                                                                                 :timezone "Etc/UTC"})
                                                    "/H1"

                                                    " | "
                                                    (dates/format start-1h-time {:pattern  "dd.MM.yyyy"
                                                                                 :timezone "Etc/UTC"})
                                                    " -> "
                                                    (dates/format end-1h-time {:pattern  "dd.MM.yyyy"
                                                                               :timezone "Etc/UTC"}))}
                                {:value        (option-value start-2h-ts end-2h-ts)
                                 :start-ts     start-2h-ts
                                 :end-ts       end-2h-ts
                                 :period-type  :reference-period/half-year
                                 :period-index 1
                                 :label        (str (dates/format start-2h-time {:pattern  "yyyy"
                                                                                 :timezone "Etc/UTC"})
                                                    "/H2"

                                                    " | "
                                                    (dates/format start-2h-time {:pattern  "dd.MM.yyyy"
                                                                                 :timezone "Etc/UTC"})
                                                    " -> "
                                                    (dates/format end-2h-time {:pattern  "dd.MM.yyyy"
                                                                               :timezone "Etc/UTC"}))}]))))
              ;:reference-period/month
              (->> (range -50 50)
                   (mapcat (fn [year-diff]
                             (let [date-in-period (dates/plus date-now (dates/years year-diff))
                                   start-dt (dates/start-of-year date-in-period)]
                               (->> (range 0 12)
                                    (mapv (fn [q]
                                            (let [date-in-start-month (dates/plus start-dt (dates/months q))
                                                  start-time (dates/start-of-month date-in-start-month)
                                                  end-time (dates/end-of-month date-in-start-month)
                                                  start-of-day (dates/start-of-day start-time)
                                                  end-of-day (dates/end-of-day end-time)
                                                  start-ts (dates/epoch-millis start-of-day)
                                                  end-ts (dates/epoch-millis end-of-day)]
                                              {:value        (option-value start-ts end-ts)
                                               :period-type  :reference-period/month
                                               :period-index q
                                               :start-ts     start-ts
                                               :end-ts       end-ts
                                               :label        (str (dates/format start-time {:pattern  "yyyy"
                                                                                            :timezone "Etc/UTC"})
                                                                  "/" (inc q))})))))))))))
    (reset! ref-periods-by-value* (->> @all-reference-periods*
                                       (map (fn [{:keys [value label]}]
                                              [value label]))
                                       (into {})))))

(defn label-by-option-value
  [option-value]
  (when (empty? @ref-periods-by-value*)
    (init-reference-periods))
  (get @ref-periods-by-value* option-value))
